var variantPriorityOrder = ["animate", "whileInView", "whileFocus", "whileHover", "whileTap", "whileDrag", "exit"];
var variantProps = ["initial"].concat(variantPriorityOrder);
export { variantPriorityOrder, variantProps };